import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './BulkUploadReport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  },
})
export default class BulkUploadReport extends Vue {
  isLoading = false;
  fromDate= new Date();
  toDate = new Date();
  perPage =10;
  currentPage= 1;
  selectedPage =1;
  totalRecords= 0;

  items = [];
  fields = [
    {
      key: "description",
      label: "Description",
      sortable: true,
    },
    {
      key: "recordCount",
      label: "Record Count",
      sortable: true,
    },
    {
      key: "finishedProcessing",
      label: "Finished Processing",
      sortable: true,
    },
    {
      key: "failedCount",
      label: "Failed Count",
      sortable: true
    },
    {
      key: "createdOn",
      label: "Uploaded At",
      sortable: true,
    },
    {
      key: "updatedOn",
      label: "Updated At",
      sortable: true,
    },
    {
      key: "id",
      label: "",
    },
  ]

  customFormatter(date:Date) {
    return moment(date).format('yyyy-MM-DD');
  }
  mounted () {
    this.getReport();
   }  

   handlePageClick(){
     if(this.currentPage === this.selectedPage)
        return;
      this.currentPage = this.selectedPage;
      this.getReport()
      }  

  getReport():void
  {
    this.isLoading = true;
    _axios.get(`${config.gateway}bulk/Report/MasterData?currentPage=${this.currentPage}&PageSize=${this.perPage}&DateFrom=${this.customFormatter(this.fromDate)}&DateTo=${this.customFormatter(this.toDate)}`)
    .then(response=>
    {
      console.log(this.items);
      this.items = response.data.files;
      this.totalRecords =response.data.totalRowCount;
    })
    .catch(err=>{console.error(err);})
    .finally(() => {
      this.isLoading = false;
    });
  }
}
